import style from "./ThankYou.module.css";
import { trackPurchase } from "@/services/pixel";
import Icon from "@/ui/icon/Icon";
import { PLAN_NAME_KEYS } from "../plans";
import i18n from "@/i18n";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Hold on the confirmation screen long enough for the user to read it
// before sending them back to the home page.
const REDIRECT_DELAY = 4500;

export function ThankYou() {
	const { t } = useTranslation();
	const queryClient = useQueryClient();
	queryClient.invalidateQueries({ queryKey: ["whoami"] });
	queryClient.invalidateQueries({ queryKey: ["courses"] });
	const navigate = useNavigate();

	useEffect(() => {
		// Report the purchase to the Meta Pixel before redirecting away.
		try {
			const pending = JSON.parse(
				localStorage.getItem("pendingPurchase")
			);
			if (pending) {
				// The Pixel report is not UI: it keeps the Bosnian plan name
				// whatever language the page is read in.
				const nameKey = PLAN_NAME_KEYS[pending.plan];
				trackPurchase({
					value: pending.value, // plaćeni iznos
					currency: pending.currency,
					plan: pending.plan, // tip plana (code)
					planName: nameKey ? i18n.t(nameKey, { lng: "bs" }) : undefined, // tip plana (readable)
					orderId: pending.orderId, // broj narudžbe
				});
			}
		} catch {
			// ignore malformed/empty value
		} finally {
			localStorage.removeItem("pendingPurchase");
		}

		const timer = setTimeout(() => navigate("/"), REDIRECT_DELAY);
		return () => clearTimeout(timer);
	}, []);

	return (
		<div className={style.wrapper}>
			<div className={style.card}>
				<div className={style.head}>
					<div className={style.badge}>
						<Icon icon="fa-check" iconType="fa-solid" />
					</div>
					<h1 className={style.title}>{t("payments:thankYou.title")}</h1>
				</div>

				<p className={style.subtitle}>
					{t("payments:thankYou.subtitle")}
				</p>

				<div className={style.divider} />

				<div className={style.progressRow}>
					<div className={style.progress}>
						<div
							className={style.progressBar}
							style={{ "--delay": `${REDIRECT_DELAY}ms` }}
						/>
					</div>
					<span className={style.redirect}>
						{t("payments:thankYou.redirecting")}
					</span>
				</div>
			</div>
		</div>
	);
}
